import React from "react";
import InputMask from "react-input-mask";

const TextInputReferenciaFormik = ({ formik, field, placeholder, mask, disabled, evento }) => {
  // Função para permitir apenas números e "/"
  const handleCustomChange = (e) => {
    const { name, value } = e.target;
    const regex = /^[0-9/]*$/; // Permite apenas números e "/"

    const numericValueMax = value.replace(/\D/g, "");

    if (regex.test(value) && numericValueMax.length <= 8) {
      formik.setFieldValue(name, value);
    }
  };

  return (
    <>
      <InputMask
        id={field}
        name={field}
        placeholder={placeholder || "Digite o valor"}
        mask={mask}
        disabled={formik.isSubmitting || disabled}
        value={formik.values[field] || ""}
        onChange={handleCustomChange}
        onBlur={evento} // Reseta a máscara se o campo estiver vazio
        className={
          formik.touched[field] && formik.errors[field]
            ? "form-control-mascara-data is-invalid"
            : "form-control-mascara-data"
        }
      />
      {formik.touched[field] && formik.errors[field] && <div className="invalid-feedback">{formik.errors[field]}</div>}
    </>
  );
};

export default TextInputReferenciaFormik;
